// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filtro-selecao-unica[data-v-c3c196e4]{display:inline-block;max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;line-height:20px;height:20px;padding:0 8px;border-radius:999px;background-color:#e0e0e0;color:#333;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
